import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import Rutas from 'src/app/Models/Base/rutas';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-password-changed',
  templateUrl: './password-changed.component.html',
  styleUrls: ['./password-changed.component.scss'],
  standalone: true,
  imports: [
    FormsModule
    , MatInputModule
    , ReactiveFormsModule
    , MatFormFieldModule
    , MatIconModule
    , CommonModule
    , RouterModule
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} }
  ]
})
export class PasswordChangedComponent {
  form: FormGroup;
  isHideOld = false;
  isHideNew = false;
  isHideRep = false;
  readonly passwordRules = [
    'La contraseña debe tener una longitud entre 10 a 50 caracteres',
    'Debe contener mínimo un carácter especial',
    'Debe contener mínimo un número',
    'Debe contener una letra en mayúscula',
    'Debe contener una letra en minúscula'
  ];

  get isAccountPage(): boolean {
    return window.location.pathname.toLowerCase() === '/' + Rutas.CHANGE_PASSWORD.toLowerCase();
  }
  constructor(
    public appStateService: AppStateService
    , @Inject(MAT_DIALOG_DATA) public payload: { accountID: string, token?: string }
    , private fb: FormBuilder) 
    {
      this.form = this.fb.group({
        oldPass: ['', [Validators.required]],
        password: ['', [Validators.required, Validators.minLength(10)]],
        confirmPass: ['', [Validators.required]],
      });
      if(this.FromAdmin){
        this.form.get('oldPass')?.clearValidators();
        this.form.updateValueAndValidity();
      }
    }

    get FromAdmin():boolean{
      const rutas = new Set<string>([Rutas.ADMINISTRATION]) 
      return rutas.has(window.location.pathname.split('/')[1])
    }

    get OldPass():string{
      return this.form.get('oldPass')?.value || '';
    }
    get NewPass():string{
      return this.form.get('password')?.value || '';
    }
    get RepNewPass():string{
      return this.form.get('confirmPass')?.value || '';
    }

    hasError(index: number): boolean{
      if(!this.NewPass.length) return true;
      const value  = this.NewPass;
      const patterns = ['[a-z]+', '[A-Z]+', '[0-9]+', '[$&+,:;=?@#|<>.^*()%!-]'];
      switch (index) {
        case 1:
          return String(value).length < 10 || String(value).length > 50
  
        case 2:
          return !String(value).match(patterns[patterns.length - 1]) || false
  
        case 3:
          return !String(value).match(patterns[patterns.length - 2]) || false
  
        case 4:
          return !String(value).match(patterns[patterns.length - 3]) || false
  
        case 5:
          return !String(value).match(patterns[patterns.length - 4]) || false
  
        default:
          return false
      }
    }
  
    get isSamePass(){
      return (!!this.NewPass.length && !!this.RepNewPass.length) && this.NewPass===this.RepNewPass
    };

    get onValidation(): boolean{
      const 
      { invalid } = this.form,
      isSame = this.isSamePass,
      hasError = [1,2,3,4,5].map(c => this.hasError(c)).filter(Boolean),
      end = !invalid && isSame && !hasError.length;
      return !end;
    }

  onSubmit(){
    if (this.onValidation || this.appStateService.loading) return;
    const 
    path = window.location.pathname.split('/')[1],
    payload = this.payload;
    switch (path) {
      case Rutas.CHANGE_PASSWORD:
      case Rutas.EXPIRATION:
        this.appStateService.AccountService.UpdateExpiredPassword(this.OldPass, this.NewPass, payload.token)
        break;
    
      default:
        this.appStateService.UserService.UpdatePasswordWithAdmin(this.NewPass, payload.accountID)
        break;
    }
  };

}
